"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import _ from "underscore";
import React from "react";
export class TableDefinition {
  constructor(component, config) {
    __publicField(this, "_config");
    __publicField(this, "component");
    __publicField(this, "renderSummary", false);
    __publicField(this, "columns");
    __publicField(this, "visibleColumns");
    __publicField(this, "tableClasses");
    __publicField(this, "headerRowClasses");
    __publicField(this, "rowKeyFn", () => "");
    __publicField(this, "emptyRowMessage", null);
    this._config = config;
    this.component = component;
    Object.assign(this, config);
    this.columns || (this.columns = []);
    this.visibleColumns = config && config.columns && config.columns.filter((x) => !x.hidden) || [];
  }
  renderTable(items, summary) {
    return /* @__PURE__ */ React.createElement("table", { className: this.tableClasses }, this.renderHeaders(), /* @__PURE__ */ React.createElement("tbody", null, this.renderRows(items), this.emptyRowMessage && items.length === 0 && this.renderNoItemsRow(), summary && this.rowSummary(summary)));
  }
  renderHeaders() {
    return /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", { className: this.headerRowClasses }, this.visibleColumns.map((column, colIdx) => {
      return /* @__PURE__ */ React.createElement("th", { key: `header-${colIdx}` }, column.title);
    })));
  }
  renderRows(items) {
    return _.map(items, this.renderRow.bind(this));
  }
  renderRow(item) {
    return this._renderRow(item, this.rowKeyFn(item), "render");
  }
  renderNoItemsRow() {
    const colCount = this.visibleColumns.length;
    return /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { colSpan: colCount }, this.emptyRowMessage));
  }
  rowSummary(item) {
    if (!this.renderSummary) {
      return null;
    }
    return this._renderRow(item, void 0, "renderSummary");
  }
  _renderRow(item, rowKey, renderFn) {
    return /* @__PURE__ */ React.createElement("tr", { key: rowKey }, this.visibleColumns.map((column, colIdx) => {
      const render = (column[renderFn] || _.noop).bind(column);
      return /* @__PURE__ */ React.createElement("td", { key: `${rowKey}--${colIdx}` }, render(item));
    }));
  }
}
